<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { getTranslatedCharacterName } from '$lib/er/character/translations';
  import CharacterIcon from '$lib/er/character/character-icon.svelte';
  import { orderBy } from '$lib/utils/array';
  import { trimTrailingZero } from '$lib/utils/number';
  import { CharacterImageType } from '$lib/er/character/consts';
  import CharacterImage from '$lib/er/character/character-image.svelte';

  export let data;
  $: player = data.player!;
</script>

<section>
  <h2>실험체 통계</h2>
  <table>
    <thead>
      <th>실험체</th>
      <th>승률</th>
      <th>반타작률</th>
      <th>평균 KDA</th>
      <th>KDA 평점</th>
      <th>스킨</th>
    </thead>
    <tbody>
      {#await player.seasonStatistics then statistics}
        {@const sortedCharacterEntries = Object.entries(statistics.characters)
          .sort(orderBy((v) => v[1].playTime, true))
          .map((v) => ({ characterId: parseInt(v[0]), stat: v[1] }))}

        {#each sortedCharacterEntries as { characterId, stat }}
          {@const avgKill = stat.kda[0] / stat.plays}
          {@const avgDeath = stat.kda[1] / stat.plays}
          {@const avgAssist = stat.kda[2] / stat.plays}
          {@const totalKill = stat.kda[0]}
          {@const totalDeath = stat.kda[1]}
          {@const totalAssist = stat.kda[2]}
          <tr>
            <td class="character">
              <CharacterIcon id={characterId} type={CharacterImageType.Lobby} skinIndex={0} />
              <div>
                <span>{getTranslatedCharacterName($LL, characterId)}</span>
                <span class="time"
                  >{stat.plays}회({trimTrailingZero(stat.playTime / 60 / 60, 1)}시간)</span
                >
              </div>
            </td>
            <td>{trimTrailingZero((stat.wins / stat.plays) * 100, 1)}%</td>
            <td>{trimTrailingZero(stat.halfRate * 100, 1)}%</td>
            <td
              >{trimTrailingZero(avgKill, 1)} / {trimTrailingZero(avgDeath, 1)} / {trimTrailingZero(
                avgAssist,
                1,
              )}</td
            >
            <td>
              <div class="score">
                {#if avgDeath === 0}
                  Perfect
                {:else}
                  <span>{trimTrailingZero(avgKill + avgAssist / avgDeath, 1)}</span>
                {/if}
                <span class="dimmed">{totalKill} / {totalDeath} / {totalAssist}</span>
              </div>
            </td>
            <td class="skins">
              {#each Object.entries(stat.skins) as [skinIndex, count]}
                <div class="skin">
                  <CharacterImage
                    id={characterId}
                    skinIndex={parseInt(skinIndex)}
                    type={CharacterImageType.Lobby}
                  />
                  <span>{count}회</span>
                </div>
              {/each}
            </td>
            <!-- <td>{Object.entries(stat.ranks).toString()}</td> -->
          </tr>
        {/each}
      {/await}
    </tbody>
  </table>
</section>

<style lang="postcss">
  section {
    font-size: var(--size-5);
    width: 100%;
  }

  table {
    width: 100%;
  }

  td {
    text-align: center;
  }
  .character {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-1);
    }
    .time {
      color: var(--text-dimmed);
    }
  }
  .score {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }

  .skins {
    display: flex;
    flex-direction: row;
    gap: var(--space-2);

    :global(img) {
      height: 4rem;
      width: auto;
    }

    .skin {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }
  }
</style>
